import {useState, useEffect} from "react";

function Location(props) {

  const [loading, setLoading] = useState(false);
  const [Location, SetLocations] = useState([]);
  const name = "Allowed_Locations";

  function loadLocations() {
    setLoading(true);
    fetch('/.netlify/functions/results?path=_PMC_Locations%3Fformat%3Djson')
        .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        })
        .then((json) => {
            if (!json.ok) throw new Error(json.error || 'Function returned ok=false');
            SetLocations(json.results.Report_Entry);
            setLoading(false);
        })
        .catch((error) => {
            console.log('ERROR LOADING INSTRUCTORS:', error);
            setLoading(false);
        });
  }

  function handleStateChange (e) {
    let coursesObj = props.coursesObj;
    props.setCoursesObj({
      ...coursesObj,
      Allowed_Locations: e.target.value,
      default: false,
    });
  }

  useEffect(() => {loadLocations()}, []);

  return (
    <>
      <span className="tooltip">
        <img className="icon" alt="Calendar Icon" src="https://www.aims.edu/themes/custom/aims/images/icons/question-mark.png"/>
        <span className="tooltiptext">If selecting a location, online courses will not be displayed.</span>
      </span>
      <label htmlFor="Location" className="majorLabel">Location:</label>
      {Location.map((location_name) => {
        if(location_name.referenceID !== props.coursesObj.Allowed_Locations){
          return [
            <>
              <input type="radio" id={location_name.referenceID} name={name} value={location_name.referenceID} className="radio" onChange={handleStateChange}/>
              <label htmlFor={location_name.referenceID}>{location_name.locationName}</label>
              <br/>
            </>
          ]
        }
        else{
          return [
            <>
              <input type="radio" id={location_name.referenceID} name={name} value={location_name.referenceID} className="radio" checked onChange={handleStateChange}/>
              <label htmlFor={location_name.referenceID}>{location_name.locationName}</label>
              <br/>
            </>
          ]
        }
      })}
    </>
  );
}

export default Location;
